export const RTL_LOCALES = ['ar', 'he', 'fa', 'ur', 'ckb', 'sd'] as const;
export enum HTMLDirection {
  LeftToRight = 'ltr',
  RightToLeft = 'rtl',
}

export const isLocaleRtL = (locale: string): boolean => {
  return RTL_LOCALES.some((rtlLanguage) => locale.startsWith(rtlLanguage));
};

export const getTextDirection = (locale: string): HTMLDirection => {
  return isLocaleRtL(locale) ? HTMLDirection.RightToLeft : HTMLDirection.LeftToRight;
};

export const updateDocumentDirection = (locale: string): void => {
  const direction = getTextDirection(locale);
  document.documentElement.dir = direction;
  document.body.dir = direction;
};
